import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'cannot-convert-component',
    templateUrl: './cannot-convert-dialog.component.html',
    styleUrls: ['./cannot-convert-dialog.component.sass']
})
export class CannotConvertComponent {
    constructor(
        public dialogRef: MatDialogRef<CannotConvertComponent>
    ) { }

    cancel() {
        this.dialogRef.close(false);
    }

    viewCase() {
        this.dialogRef.close(true);
    }
}